import React from "react";
import { motion } from "framer-motion";
import { MotionModal } from "../motion";
import { CloseIcon } from "../icons";

/**
 * General-purpose popup (confirmation, disclaimer, client info…).
 * Built on MotionModal: soft tinted backdrop, panel rises in, Esc / backdrop
 * click / ✕ close it. Props are unchanged from the old Bootstrap-style version.
 *
 * @param {boolean} show
 * @param {Function} onClose
 * @param {string} [title] - optional heading; a hairline separates it from the body
 * @param {string} [paddingBody] - Tailwind padding for the body
 * @param {string} [modalSize] - Tailwind max-width for the panel
 */
const InfoModal = ({
    show,
    children,
    onClose,
    title = "",
    paddingBody = "tw:p-6",
    modalSize = "tw:max-w-5xl",
}) => {
    const titleId = title ? "info-modal-title" : undefined;

    return (
        <MotionModal
            show={show}
            onClose={onClose}
            labelledBy={titleId}
            maxWidthClassName={modalSize}
            panelClassName="tw:max-h-[90vh] tw:overflow-y-auto tw:!rounded-md"
        >
            <div className="tw:px-6 tw:pt-6 tw:pb-0">
                <div
                    className={`tw:flex tw:items-center tw:justify-between tw:pb-6 ${title !== "" ? "tw:border-b tw:border-gray-200" : ""}`}
                >
                    <span id={titleId} className="tw:text-center tw:text-[16px] tw:font-medium">
                        {title}
                    </span>
                    <motion.button
                        type="button"
                        aria-label="Close"
                        onClick={onClose}
                        className="tw:flex tw:h-8 tw:w-8 tw:items-center tw:justify-center tw:rounded-full tw:transition-colors tw:hover:bg-[#F6F6F6]"
                        whileTap={{ scale: 0.92 }}
                    >
                        <CloseIcon size={12} color="#6B6B6B" />
                    </motion.button>
                </div>
            </div>

            <div className={paddingBody}>{children}</div>
        </MotionModal>
    );
};

export default InfoModal;
